import {Component, EventEmitter, Input, Output} from "@angular/core";
import {AppSearchFacets} from "../../../models/appSearch.model";

@Component(
        {
            selector: 'catalogue-app-search-facets',
            templateUrl: './app-search-facets.component.html',
            styleUrls: [
                './app-search-facets.component.scss'
            ],
        }
)
export class AppSearchFacetsComponent {
    @Input() public facets: AppSearchFacets[];
    @Output() public toggleFacetOption = new EventEmitter();

    public hasCheckedFacets(): boolean {
        return this.facets.filter(
                facetTypes => facetTypes.filter(
                        facet => facet.options.filter(
                                facetOption => facetOption.checked
                        ).length
                ).length
        ).length > 0;
    }

    public clearFacets() {
        this.facets.map(
                facetTypes => facetTypes.map(
                        facet => facet.options.map(
                                facetOption => facetOption.checked = false
                        )
                )
        );

        this.toggleFacetOption.emit();
    }

    public toggleFacetsBar() {
        if (document.body.classList.contains('filter-sidebar-show')) {
            document.body.classList.remove('filter-sidebar-show');
        } else {
            document.body.classList.add('filter-sidebar-show');
        }
    }
}